import React from 'react';
import { ClerkProvider, RedirectToSignIn, useUser } from '@clerk/clerk-react';
import { TestUserAutoSignIn, shouldBypassTestRedirect } from './testUserAuth';
import { Loader } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error('CLERK_PUBLISHABLE_KEY is not set');
}
/**
 * Root Clerk provider. Does not enforce authentication by itself.
 * Use `RequireAuth` around protected routes.
 */
export function AuthProvider({ children }) {
    return (React.createElement(ClerkProvider, { publishableKey: CLERK_PUBLISHABLE_KEY, afterSignOutUrl: "/" },
        React.createElement(TestUserAutoSignIn, null),
        children));
}
/**
 * Guard for protected routes.
 * Redirects to Clerk while preserving the current path.
 */
export function RequireAuth({ children }) {
    const location = useLocation();
    const { isLoaded, isSignedIn } = useUser();
    if (!isLoaded) {
        return React.createElement(Loader, { active: true, inline: "centered" });
    }
    if (!isSignedIn) {
        if (shouldBypassTestRedirect) {
            return React.createElement(Loader, { active: true, inline: "centered" });
        }
        const redirectUrl = `${location.pathname}${location.search}${location.hash || ''}`;
        return React.createElement(RedirectToSignIn, { redirectUrl: redirectUrl });
    }
    return React.createElement(React.Fragment, null, children);
}
export function AuthLoader({ children }) {
    return (React.createElement(RequireAuth, null,
        React.createElement(AuthLoaderContent, null, children)));
}
export function AuthLoaderContent({ children }) {
    const { isLoaded, isSignedIn } = useUser();
    if (!isLoaded)
        return React.createElement(Loader, { active: true, inline: "centered" });
    if (!isSignedIn)
        return React.createElement(Loader, { active: true, inline: "centered" });
    return React.createElement(React.Fragment, null, children);
}
